import { render, staticRenderFns } from "./integralShop.vue?vue&type=template&id=f95eb1c2&scoped=true"
import script from "./integralShop.vue?vue&type=script&lang=js"
export * from "./integralShop.vue?vue&type=script&lang=js"
import style0 from "./integralShop.vue?vue&type=style&index=0&id=f95eb1c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95eb1c2",
  null
  
)

export default component.exports